import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { blue, orange } from "@material-ui/core/colors";
import Box from "@mui/material/Box";
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import AccessTimeFilledTwoToneIcon from "@mui/icons-material/AccessTimeFilledTwoTone";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
//import Table from "@mui/material/Table";
//import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
//import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
//import TableContainer from "@mui/material/TableContainer";
import EditIcon from "@mui/icons-material/Edit";
import { EvaluationService, MasService } from "src/services";
//import { UserService } from "src/services";
//import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import AssignmentIcon from "@mui/icons-material/Assignment";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { PageLoading } from "src/components";
import TableComponent from "./UI/TableComponent";
import TableEmptyComponent from "./UI/TableEmptyComponent";
import TableBodyCellComponent from "./UI/TableBodyCellComponent";
import { useParams } from 'react-router';
import { useLocation } from "react-router-dom";
import { Autocomplete, createFilterOptions } from "@mui/material";
import { saveAs } from "file-saver";
import moment from "moment";
import { userStorage } from "src/common/Storage";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: "3%",
    marginRight: "3%",
    marginTop: "2%",
  },
  head: {
    color: "#0009b7",
    fontWeight: "regular",
  },
  cardBack: {
    backgroundColor: blue[500],
  },
  Roundborder: {
    border: "0.5px outset #cfcfcf",
    borderRadius: "5px",
    marginTop: "1%",
    marginBottom: "2%",
    backgroundColor: "white",
  },
  textarea: {
    resize: "both",
  },
  tableContainer: {
    overflowY: "auto",
  },
  table: {
    //...
    height: "100%",
    overflowY: "scroll",
  },
  ImageIcon: {
    // marginTop: theme.spacing(3),
    width: 25,
    // [theme.breakpoints.down("md")]: {
    //   width: 30,
    // },
  },
  largeIcon: {
    width: 60,
    height: 60,
  },
}));

const ColorIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.getContrastText(orange[500]),
  backgroundColor: orange[500],
  "&:hover": {
    backgroundColor: orange[700],
  },
}));

const inputGrid1 = {
  version: "",
  evaluationName: "",
  startDate: "",
  endDate: "",
};
const inputGrid2 = {
  version: "",
  evaluationName: "",
  startDate: "",
  endDate: "",
  isActive: true,
};

function convert(str) {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [day, mnth, date.getFullYear()].join("/");
}

const checkHasRole = (roleCodes, role) => {
  const roleArray = roleCodes.split(",");
  const hasRole = (roleArray.indexOf(role) > -1); 

  if (hasRole)
    return true;
  else
    return false;
};

function EvaluationScreen() {
  const location = useLocation();
  const classes = useStyles();
  const { t } = useTranslation();
  const { menuParameter } = useParams();
  //const [onProgress, setOnProgress] = useState(true);

  const columns = [
    { id: "id", label: "", minWidth: 50 },
    { id: "version", label: "Version", minWidth: 100, align: "left" },
    { id: "evaluationName", label: <>{t("EvaForm.assName")}</>, minWidth: 170, align: "left", },
    { id: "status", label: <>{t("EvaForm.status")}</>, minWidth: 100, align: "center", },
    { id: "startDate", label: <>{t("EvaForm.startDate")}</>, minWidth: 100, align: "center", format: (value) => value.toLocaleString("en-US"), },
    { id: "endDate", label: <>{t("EvaForm.endDate")}</>, minWidth: 100, align: "center", format: (value) => value.toLocaleString("en-US"), },
    { id: "actionName", label: <>{t("EvaForm.recorder")}</>, minWidth: 100, align: "center", format: (value) => value.toFixed(2), },
    { id: "lastActionDate", label: <>{t("EvaForm.implementDate")}</>, minWidth: 100, align: "center", format: (value) => value.toFixed(2), },
  ];
  
  const columnsTab2 = [
    { id: "id", label: "", minWidth: 50 },
    { id: "version", label: "Version", minWidth: 100, align: "left" },
    { id: "evaluationName", label: <>{ menuParameter === 'General' ? t("EvaForm.assName") : t("EvaForm.assName2")}</>, minWidth: 170, align: "left", },
    { id: "status", label: <>{t("VendorSelf.status")}</>, minWidth: 100, align: "left" },
    { id: "startDate", label: <>{t("EvaForm.startDate")}</>, minWidth: 100, align: "center", format: (value) => value.toLocaleString("en-US"), },
    { id: "endDate", label: <>{t("EvaForm.endDate")}</>, minWidth: 100, align: "center", format: (value) => value.toLocaleString("en-US"), },
    { id: "actionName", label: <>{t("EvaForm.recorder")}</>, minWidth: 100, align: "center", format: (value) => value.toFixed(2), },
    { id: "lastActionDate", label: <>{t("EvaForm.implementDate")}</>, minWidth: 100, align: "center", format: (value) => value.toFixed(2), },
  ];

  const userInfo = userStorage.getUser();
  const userProfile = userInfo?.userProfile || {};
  
  const isAdminEsg = checkHasRole(userInfo?.userProfile?.roleCode, "ADMIN_ESG");

  const [tabpage, tabpagesetValue] = useState("1");

  const [evalText1, SetevalText1] = useState("");
  const [evalText2, SetevalText2] = useState("");

  const [Datevalue1, DatesetValue1] = useState(null);
  const [Datevalue2, DatesetValue2] = useState(null);
  const [ddlVersion, setddlVersion] = useState([]);
  const [ddlVersion2, setddlVersion2] = useState([]);

  const [rows, setrows] = useState([]);
  const [rowsTab2, setrowsTab2] = useState([]);

  const [Version, setVersion] = useState("");
  const [Version2, setVersion2] = useState("");

  const handleChangeVersion = (event) => {
    setVersion(event.target.textContent);
  };
  const handleChangeVersion2 = (event) => {
    setVersion2(event.target.textContent);
  };

  const [Datevalue1tab2, DatesetValue1tab2] = useState(null);
  const [Datevalue2tab2, DatesetValue2tab2] = useState(null);

  const [onLoading, setOnLoading] = useState(false);

  const tabhandleChange = (event, tabnewValue) => {
    tabpagesetValue(tabnewValue);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const EditBtnTab2 = (a) => {
    window.location.href = "/Evaluation/Create/".concat(a);
  };
  const SearchBtnTab2 = (a) => {
    window.location.href = "/Evaluation/View/".concat(a);
  };
  const ExcalBtnTab2 = (a) => {
    setOnLoading(true);
    EvaluationService.GetEvaFormExcelExport(a)
      .then((data) => {
        saveAs(
          data,
          "EvaFormExcelExport_" + moment().format("YYYYMMDD") + ".xlsx"
        );
      })
      .then(() => setOnLoading(false));
  };

  const SearchGrid1 = () => {
    setOnLoading(true);
    inputGrid1.version = Version === "--- ทั้งหมด ---" ? "" : Version;
    inputGrid1.evaluationName = evalText1;
    inputGrid1.startDate = Datevalue1 ? convert(Datevalue1) : "";
    inputGrid1.endDate = Datevalue2 ? convert(Datevalue2) : "";
    EvaluationService.GridData(inputGrid1).then((resp) => {
      setrows(resp);
      setOnLoading(false);
    });
  };
  const SearchGrid2 = () => {
    setOnLoading(true);
    inputGrid2.version = Version2 === "--- ทั้งหมด ---" ? "" : Version2;
    inputGrid2.evaluationName = evalText2;
    inputGrid2.startDate = Datevalue1tab2 ? convert(Datevalue1tab2) : "";
    inputGrid2.endDate = Datevalue2tab2 ? convert(Datevalue2tab2) : "";
    inputGrid2.isActive = false;
    EvaluationService.GridDataReport(inputGrid2).then((resp) => {
      setrowsTab2(resp);
      setOnLoading(false);
    });
  };
  const editIconTab2 = (data) => (
    <Grid container columns={16} direction="row" justifyContent="left">
      <IconButton onClick={() => ExcalBtnTab2(data)}>
        {/* <EditIcon  fontSize="small"/> */}
        <img className={classes.ImageIcon} alt="Logo" src="/images/excel.png" />
      </IconButton>
      <IconButton onClick={() => SearchBtnTab2(data)}>
        <AssignmentIcon fontSize="small" />
      </IconButton>
      {location.pathname === "/Evaluation" ? (
        <IconButton onClick={() => EditBtnTab2(data)}>
          <EditIcon fontSize="small" />
        </IconButton>
      ) : (
        ""
      )}
    </Grid>
  );

  const IconText = (data) => (
    <Grid container columns={16} direction="row" justifyContent="left">
      <FiberManualRecordIcon
        size="small"
        sx={{
          color:
            data === "แบบประเมินประกาศใช้งาน"
              ? "#03FC7B"
              : data === "แบบประเมินรอประกาศใช้งาน"
                ? "#8a8a8a"
                : data === "แบบประเมินไม่ใช้งาน"
                  ? "#ff0b0b"
                  : "",
        }}
      />
      {data}
    </Grid>
  );

  const RenderBody = (row, i, currentTab) => {
    if (currentTab === 1) {
      return (
        <TableRow hover role="checkbox" tabIndex={-1} key={i}>
          <TableBodyCellComponent columns={columns} row={row} />
        </TableRow>
      );
    } else if (currentTab === 2) {
      return (
        <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
          {columnsTab2.map((column) => {
            const value = row[column.id];
            return (
              <TableCell key={column.id} align={column.align}>
                {column.id === "id"
                  ? editIconTab2(value)
                  : column.id === "status"
                    ? IconText(value)
                    : value}
              </TableCell>
            );
          })}
        </TableRow>
      );
    }
  };

  const setTableBody = (rows, page, rowsPerPage, currentTab) => {
    if (currentTab === 1) {
      return rows.length > 0 ? (
        rows
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, i) => {
            return RenderBody(row, i, currentTab);
          })
      ) : (
        <TableEmptyComponent />
      );
    } else if (currentTab === 2) {
      return rows.length > 0 ? (
        rows
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, i) => {
            return RenderBody(row, i, currentTab);
          })
      ) : (
        <TableEmptyComponent />
      );
    }
  };

  const evaluationContent = () => {
    return (
      <TabContext value={tabpage}>
        <Box sx={{ borderBottom: 1, borderColor: "divider", width: "100%" }}>
          <TabList onChange={tabhandleChange}>
            <Tab label={t("EvaForm.pendingAssessment")} value="1"></Tab>
            <Tab label={t("EvaForm.assList")} value="2"></Tab>
          </TabList>
        </Box>
        <TabPanel value="1" className={classes.Roundborder}>
          {/* Item One */}
          <Grid
            container
            style={{ fontWeight: "bold" }}
            direction="row"
            justifyContent="left"
          >
            <AccessTimeFilledTwoToneIcon sx={{ color: "#FFBA08" }} />
            {t("EvaForm.pendingAssessment")}
          </Grid>
          <br />
          <Grid
            container
            rowSpacing={2}
            spacing={1}
            columns={16}
            direction="row"
            alignContent="center"
            justifyContent="center"
          >
            <Grid item xs={3}>
              <FormControl sx={{ width: "100%" }}>
                <Autocomplete
                  id="idVersion"
                  size="small"
                  options={ddlVersion}
                  filterOptions={createFilterOptions({
                    limit: 20,
                  })}
                  value={
                    ddlVersion.filter((x) => x.label === Version).length > 0
                      ? ddlVersion.filter((x) => x.label === Version)[0]
                      : ""
                  }
                  renderInput={(params) => (
                    <TextField size="small" {...params} label="Version" />
                  )}
                  onChange={(event) => {
                    handleChangeVersion(event);
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={8}>
              <TextField
                size="small"
                onChange={(e) => SetevalText1(e.target.value)}
                style={{ backgroundColor: "white" }}
                fullWidth
                id="outlined-search"
                label={t("EvaForm.assName")}
                type="search"
                inputProps={{ className: classes.textarea }}
              />
            </Grid>
            <Grid item xs={2}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  mask="____/__/__"
                  value={Datevalue1}
                  onChange={(newValue) => DatesetValue1(newValue)}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      style={{ backgroundColor: "white" }}
                      placeholder="testttt"
                      fullWidth
                      {...params}
                      inputProps={{
                        ...params.inputsProps,
                        placeholder: t("EvaForm.startDate"),
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={2}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  mask="____/__/__"
                  value={Datevalue2}
                  onChange={(newValue) => DatesetValue2(newValue)}
                  placeholder="testt"
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      style={{ backgroundColor: "white" }}
                      fullWidth
                      {...params}
                      inputProps={{
                        ...params.inputsProps,
                        placeholder: t("EvaForm.endDate"),
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={1}>
              <ColorIconButton
                sx={{ color: "#ffa489", backgroundColor: "#FFA489" }}
                size="small"
                onClick={() => SearchGrid1()}
              >
                <SearchRoundedIcon sx={{ color: "white" }} />
              </ColorIconButton>
            </Grid>
            <Grid item xs={16}>
              <Paper sx={{ width: "100%", overflow: "hidden" }}>
                <TableComponent
                  headerColumns={columns}
                  tableBody={setTableBody(rows, page, rowsPerPage, 1)}
                />
                <TablePagination
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  component="div"
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value="2" className={classes.Roundborder}>
          {/* Item Two */}
          <Grid
            container
            style={{ fontWeight: "bold" }}
            direction="row"
            justifyContent="left"
          >
            {t("EvaForm.assList")}
          </Grid>
          <br />
          <Grid
            container
            rowSpacing={2}
            spacing={1}
            columns={16}
            direction="row"
            alignContent="center"
            justifyContent="center"
          >
            <Grid item xs={3}>
              <FormControl sx={{ width: "100%" }}>
                <Autocomplete
                  id="idVersion"
                  size="small"
                  options={ddlVersion2}
                  filterOptions={createFilterOptions({
                    limit: 20,
                  })}
                  value={
                    ddlVersion2.filter((x) => x.label === Version2).length > 0
                      ? ddlVersion2.filter((x) => x.label === Version2)[0]
                      : ""
                  }
                  renderInput={(params) => (
                    <TextField size="small" {...params} label="Version" />
                  )}
                  onChange={(event) => {
                    handleChangeVersion2(event);
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={8}>
              <TextField
                size="small"
                onChange={(e) => SetevalText2(e.target.value)}
                style={{ backgroundColor: "white" }}
                fullWidth
                id="outlined-search"
                label={t("EvaForm.assName2")}
                type="search"
                inputProps={{ className: classes.textarea }}
              />
            </Grid>
            <Grid item xs={2}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  mask="____/__/__"
                  inputFormat="dd/MM/yyyy"
                  value={Datevalue1tab2}
                  onChange={(newValue) => DatesetValue1tab2(newValue)}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      style={{ backgroundColor: "white" }}
                      fullWidth
                      {...params}
                      inputProps={{
                        ...params.inputsProps,
                        placeholder: t("EvaForm.startDate"),
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={2}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  mask="____/__/__"
                  inputFormat="dd/MM/yyyy"
                  value={Datevalue2tab2}
                  onChange={(newValue) => DatesetValue2tab2(newValue)}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      style={{ backgroundColor: "white" }}
                      fullWidth
                      {...params}
                      inputProps={{
                        ...params.inputsProps,
                        placeholder: t("EvaForm.endDate"),
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={1}>
              <ColorIconButton
                sx={{ color: "#ffa489", backgroundColor: "#FFA489" }}
                aria-label="search"
                color="warning"
                size="small"
                onClick={() => SearchGrid2()}
              >
                <SearchRoundedIcon sx={{ color: "white" }} />
              </ColorIconButton>
            </Grid>
            <Grid item xs={16}>
              <Paper sx={{ width: "100%", overflow: "hidden" }}>
                <TableComponent
                  headerColumns={columnsTab2}
                  tableBody={setTableBody(rowsTab2, page, rowsPerPage, 2)}
                />
                <TablePagination
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  component="div"
                  count={rowsTab2.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </Grid>
          </Grid>
        </TabPanel>
      </TabContext>
    );
  };

  const evaluationGeneralContent = () => {
    return (
      <Box className={classes.Roundborder} sx={{ width: "100%" }}>
        <Box sx={{ margin: "20px", backgroundColor: "white" }}>
          <Grid
            container
            style={{ fontWeight: "bold" }}
            direction="row"
            justifyContent="left"
          >
            {t("EvaForm.assList")}
          </Grid>
          <br />
          <Grid
            container
            rowSpacing={2}
            spacing={1}
            columns={16}
            direction="row"
            alignContent="center"
            justifyContent="center"
          >
            <Grid item xs={3}>
              <FormControl sx={{ width: "100%" }}>
                <Autocomplete
                  id="idVersion"
                  size="small"
                  options={ddlVersion2}
                  filterOptions={createFilterOptions({
                    limit: 20,
                  })}
                  value={
                    ddlVersion2.filter((x) => x.label === Version2).length > 0
                      ? ddlVersion2.filter((x) => x.label === Version2)[0]
                      : ""
                  }
                  renderInput={(params) => (
                    <TextField size="small" {...params} label="Version" />
                  )}
                  onChange={(event) => {
                    handleChangeVersion2(event);
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={8}>
              <TextField
                size="small"
                onChange={(e) => SetevalText2(e.target.value)}
                style={{ backgroundColor: "white" }}
                fullWidth
                id="outlined-search"
                label={t("EvaForm.assName")}
                type="search"
                inputProps={{ className: classes.textarea }}
              />
            </Grid>
            <Grid item xs={2}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  mask="____/__/__"
                  inputFormat="dd/MM/yyyy"
                  value={Datevalue1tab2}
                  onChange={(newValue) => DatesetValue1tab2(newValue)}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      style={{ backgroundColor: "white" }}
                      fullWidth
                      {...params}
                      inputProps={{
                        ...params.inputsProps,
                        placeholder: t("EvaForm.startDate"),
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={2}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  mask="____/__/__"
                  inputFormat="dd/MM/yyyy"
                  value={Datevalue2tab2}
                  onChange={(newValue) => DatesetValue2tab2(newValue)}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      style={{ backgroundColor: "white" }}
                      fullWidth
                      {...params}
                      inputProps={{
                        ...params.inputsProps,
                        placeholder: t("EvaForm.endDate"),
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={1}>
              <ColorIconButton
                sx={{ color: "#ffa489", backgroundColor: "#FFA489" }}
                aria-label="search"
                color="warning"
                size="small"
                onClick={() => SearchGrid2()}
              >
                <SearchRoundedIcon sx={{ color: "white" }} />
              </ColorIconButton>
            </Grid>
            <Grid item xs={16}>
              <Paper sx={{ width: "100%", overflow: "hidden" }}>
                <TableComponent
                  headerColumns={columnsTab2}
                  tableBody={setTableBody(rowsTab2, page, rowsPerPage, 2)}
                />
                <TablePagination
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  component="div"
                  count={rowsTab2.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>
    );
  };

  useEffect(() => {
    setOnLoading(true);
    MasService.GetEvaluationVersionByStatusForm(1).then((resp) => {
      var tmp = [{ value: "--- ทั้งหมด ---", label: "--- ทั้งหมด ---" }];
      for (var i = 0; i < resp.data.length; i++) {
        tmp.push(resp.data[i]);
      }
      setddlVersion(tmp);
    });

    MasService.GetEvaluationVersionByStatusForm(2).then((resp) => {
      var tmp = [{ value: "--- ทั้งหมด ---", label: "--- ทั้งหมด ---" }];
      for (var i = 0; i < resp.data.length; i++) {
        tmp.push(resp.data[i]);
      }
      setddlVersion2(tmp);
    });

    EvaluationService.GridData(inputGrid1).then((resp) => {
      setrows(resp);
    });
    inputGrid2.isActive = true;
    EvaluationService.GridDataReport(inputGrid2).then((resp) => {
      setrowsTab2(resp);
      setOnLoading(false);
    });
  }, []);

  return (
    <div className={classes.root}>
      <PageLoading open={onLoading} />
      <CssBaseline>
        <div className={classes.head}>
          <Grid
            columns={20}
            container
            direction="row"
            justifyContent="space-between"
            alignContent="center"
            alignItems="center"
          >
            <Grid item xs={17}>
              <item>
                <h1>{ isAdminEsg === true ? t("EvaForm.assManagement") : t("EvaForm.assTemplate") }</h1>
              </item>
            </Grid>
            {location.pathname === "/Evaluation" ? (
              <Grid item style={{ flexGrow: "1" }}>
                <item>
                  <Stack direction="row" spacing={4}>
                    <Button
                      sx={{
                        color: "white",
                        padding: "5px",
                        boxShadow: 3,
                        margin: "5px",
                      }}
                      onClick={() => {
                        window.location.href = "/Evaluation/Create";
                      }}
                      variant="outlined"
                      // startIcon={}
                      style={{
                        flexGrow: "1",
                        backgroundColor: "#0FBEF5",
                        border: "2px solid #0FBEF5",
                        borderRadius: "5px",
                        borderColor: "#0FBEF5",
                      }}
                    >
                      {/* <AssignmentIcon sx={{ fontSize: 70 }}  /> */}
                      <img
                        // className={classes.ImageIcon}
                        sx={{ width: 25 }}
                        alt="Logo"
                        src="/images/doc_create_esg.png"
                      />
                      <Stack
                        sx={{
                          marginLeft: "10px",
                          marginTop: "4px",
                          boxShadow: 3,
                          backgroundColor: "#053BFB",
                          border: "5px solid #053BFB",
                          borderRadius: "5px 5px",
                          fontWeight: "bold",
                          width:"100px"
                        }}
                      >
                        {t("EvaForm.createESG")}
                      </Stack>
                    </Button>
                  </Stack>
                </item>
              </Grid>
            ) : (
              <Grid item style={{ flexGrow: "1" }}></Grid>
            )}
          </Grid>
        </div>
      </CssBaseline>
      <br />
      <Box sx={{ width: "100%" }}>
        {location.pathname === "/Evaluation"
          ? evaluationContent()
          : evaluationGeneralContent()}
      </Box>
    </div>
  );
}

export default EvaluationScreen;
